// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import { arenaRequest } from "./api.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { ArenaDialog } from "./ArenaDialog.jsx";
import { de } from "./ArenaDialog.jsx";
import { IconArrowLeft } from "../../components/icons.jsx";
import { Ji } from "./ArenaMedia.jsx";
import { ArenaMedia } from "./ArenaMedia.jsx";
import { IconSword } from "../../components/icons.jsx";
import { ma } from "./ArenaMedia.jsx";
import { IconCheck } from "../../components/icons.jsx";
import { IconEye } from "../../components/icons.jsx";
import { IconTrash } from "../../components/icons.jsx";
import { IconSearch } from "../../components/icons.jsx";
import { IconPlus } from "../../components/icons.jsx";
export const Ag = ["Все", "Absolute", "LIMITED", "Mystic", "Majestic", "Elite", "Advanced", "Basic"];
export function ArenaDeckPicker({
  slot: u,
  current: o,
  busy: m,
  mutationError: r,
  onClose: g,
  onSelect: j,
  onRemove: B
}) {
  const [U, N] = React.useState(""),
    [y, X] = React.useState(""),
    [M, R] = React.useState({
      cards: [],
      nextOffset: null
    }),
    [H, Y] = React.useState(!0),
    [P, W] = React.useState(""),
    [ee, ie] = React.useState(0),
    [w, I] = React.useState(null),
    [ne, oe] = React.useState(!1),
    T = React.useRef(null),
    D = React.useRef(!1);
  React.useEffect(() => {
    const Z = new AbortController();
    T.current = Z, D.current = !0, Y(!0), W(""), R({
      cards: [],
      nextOffset: null
    });
    const V = window.setTimeout(() => {
      arenaRequest("deck/cards", {
        slot: u,
        search: U,
        rarity: y
      }, Z.signal).then(ae => {
        Z.signal.aborted || R(ae);
      }).catch(ae => {
        Z.signal.aborted || W(ae instanceof Error ? ae.message : "Не удалось загрузить карты");
      }).finally(() => {
        Z.signal.aborted || (Y(!1), D.current = !1);
      });
    }, U ? 250 : 0);
    return () => {
      window.clearTimeout(V), Z.abort(), T.current?.abort();
    };
  }, [u, U, y, ee]);
  async function le() {
    if (D.current || M.nextOffset === null) return;
    D.current = !0;
    const Z = new AbortController();
    T.current = Z, Y(!0), W("");
    try {
      const V = await arenaRequest("deck/cards", {
        slot: u,
        search: U,
        rarity: y,
        offset: M.nextOffset
      }, Z.signal);
      Z.signal.aborted || R(ae => ({
        cards: [...ae.cards, ...V.cards],
        nextOffset: V.nextOffset
      }));
    } catch (V) {
      Z.signal.aborted || W(V instanceof Error ? V.message : "Не удалось загрузить карты");
    } finally {
      Z.signal.aborted || (D.current = !1, Y(!1));
    }
  }
  const te = w ? w.card.damage - (o?.damage ?? 0) : 0;
  return jsxRuntime.jsxs(ArenaDialog, {
    title: `Слот ${u} · ${o ? "Замена карты" : "Выбор карты"}`,
    busy: m,
    onClose: g,
    children: [r && jsxRuntime.jsx("p", {
      className: de.error,
      role: "alert",
      children: r
    }), w ? jsxRuntime.jsxs("section", {
      className: de.preview,
      children: [jsxRuntime.jsxs("button", {
        type: "button",
        className: de.backButton,
        onClick: () => I(null),
        disabled: m,
        children: [jsxRuntime.jsx(IconArrowLeft, {}), " К выбору карты"]
      }), jsxRuntime.jsx("div", {
        className: `${de.previewArt} ${de[Ji(w.card.rarity)]}`,
        children: jsxRuntime.jsx(ArenaMedia, {
          card: w.card,
          playback: !0
        }, `${w.card.id}:${w.card.thumbnailPath}`)
      }), jsxRuntime.jsx("span", {
        className: de.rarityLabel,
        children: w.card.rarity
      }), jsxRuntime.jsx("h3", {
        children: w.card.name
      }), jsxRuntime.jsxs("div", {
        className: de.previewStats,
        children: [jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx(IconSword, {}), " АТК ", jsxRuntime.jsx("b", {
            children: ma(w.card.damage)
          })]
        }), !w.current && jsxRuntime.jsxs("small", {
          className: te >= 0 ? de.gain : de.loss,
          children: [te > 0 ? "+" : "", ma(te), " к силе колоды"]
        })]
      }), jsxRuntime.jsx("p", {
        className: de.muted,
        children: w.card.modifier
      }), !w.current && jsxRuntime.jsxs("button", {
        type: "button",
        className: de.primaryButton,
        disabled: m || w.card.id === null,
        onClick: () => j(w.card),
        children: [jsxRuntime.jsx(IconCheck, {}), m ? "Сохраняем…" : o ? "Заменить карту" : "Добавить в колоду"]
      })]
    }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [o && jsxRuntime.jsxs("div", {
        className: de.currentCard,
        children: [jsxRuntime.jsx("button", {
          type: "button",
          className: `${de.currentArt} ${de[Ji(o.rarity)]}`,
          "aria-label": `Просмотреть ${o.name}`,
          onClick: () => I({
            card: o,
            current: !0
          }),
          children: jsxRuntime.jsx(ArenaMedia, {
            card: o
          })
        }), jsxRuntime.jsxs("div", {
          children: [jsxRuntime.jsxs("small", {
            children: ["СЕЙЧАС В СЛОТЕ · ", o.rarity]
          }), jsxRuntime.jsx("b", {
            children: o.name
          }), jsxRuntime.jsxs("span", {
            children: ["АТК ", ma(o.damage)]
          }), jsxRuntime.jsxs("div", {
            className: de.currentActions,
            children: [jsxRuntime.jsxs("button", {
              type: "button",
              onClick: () => I({
                card: o,
                current: !0
              }),
              disabled: m,
              children: [jsxRuntime.jsx(IconEye, {}), " Просмотр"]
            }), jsxRuntime.jsxs("button", {
              type: "button",
              onClick: () => oe(!0),
              disabled: m,
              children: [jsxRuntime.jsx(IconTrash, {}), " Убрать"]
            })]
          })]
        })]
      }), ne && jsxRuntime.jsxs("div", {
        className: de.confirmInline,
        children: [jsxRuntime.jsxs("p", {
          children: ["Убрать карту из слота ", u, "? Она останется в коллекции."]
        }), jsxRuntime.jsxs("div", {
          children: [jsxRuntime.jsx("button", {
            type: "button",
            className: de.secondaryButton,
            onClick: () => oe(!1),
            disabled: m,
            children: "Отмена"
          }), jsxRuntime.jsx("button", {
            type: "button",
            className: de.dangerButton,
            onClick: B,
            disabled: m,
            children: m ? "Убираем…" : "Убрать карту"
          })]
        })]
      }), jsxRuntime.jsx("p", {
        className: de.pickerHint,
        children: "Показаны доступные карты вашей вселенной. В колоде — до одной LIMITED и Mystic, без повторов карт и модификаторов."
      }), jsxRuntime.jsxs("label", {
        className: de.search,
        children: [jsxRuntime.jsx(IconSearch, {}), jsxRuntime.jsx("input", {
          type: "search",
          value: U,
          onChange: Z => N(Z.target.value),
          placeholder: "Найти карту",
          "aria-label": "Поиск карт",
          maxLength: 100,
          disabled: m
        })]
      }), jsxRuntime.jsx("div", {
        className: de.filters,
        "aria-label": "Редкость",
        children: Ag.map(Z => jsxRuntime.jsx("button", {
          type: "button",
          "aria-pressed": (y || "Все") === Z,
          onClick: () => X(Z === "Все" ? "" : Z),
          disabled: m,
          children: Z
        }, Z))
      }), jsxRuntime.jsx("p", {
        className: de.sortNote,
        children: "Сначала сильные · нажмите, чтобы сравнить"
      }), jsxRuntime.jsx("div", {
        className: de.pickerGrid,
        "aria-busy": H,
        children: M.cards.map(Z => jsxRuntime.jsxs("button", {
          type: "button",
          className: `${de.choice} ${de[Ji(Z.rarity)]}`,
          disabled: m,
          onClick: () => I({
            card: Z,
            current: !1
          }),
          children: [jsxRuntime.jsx(ArenaMedia, {
            card: Z
          }), jsxRuntime.jsxs("span", {
            className: de.choiceInfo,
            children: [jsxRuntime.jsx("small", {
              children: Z.rarity
            }), jsxRuntime.jsx("b", {
              children: Z.name
            }), jsxRuntime.jsxs("span", {
              children: [jsxRuntime.jsx(IconSword, {}), " ", ma(Z.damage), jsxRuntime.jsx(IconPlus, {})]
            }), jsxRuntime.jsx("em", {
              children: Z.modifier
            })]
          })]
        }, `${Z.id}:${Z.rarity}`))
      }), H && jsxRuntime.jsx("p", {
        className: de.status,
        role: "status",
        children: "Загружаем карты…"
      }), P && jsxRuntime.jsxs("div", {
        className: de.error,
        role: "alert",
        children: [P, jsxRuntime.jsx("button", {
          type: "button",
          onClick: () => M.cards.length ? void le() : ie(Z => Z + 1),
          children: "Повторить"
        })]
      }), !H && !P && !M.cards.length && jsxRuntime.jsxs("div", {
        className: de.emptyState,
        children: [jsxRuntime.jsx(IconSearch, {}), jsxRuntime.jsx("b", {
          children: U || y ? "Карт не найдено" : "Нет доступных карт"
        }), jsxRuntime.jsx("p", {
          children: U || y ? "Попробуйте другое название или редкость." : "Откройте новые карты или освободите другой слот."
        })]
      }), !P && M.nextOffset !== null && jsxRuntime.jsx("button", {
        type: "button",
        className: de.secondaryButton,
        disabled: H || m,
        onClick: () => {
          le();
        },
        children: "Показать ещё"
      })]
    })]
  });
}
